import { useMemo, useRef, type ReactElement } from 'react';
import { Box, Block, Icons, AgGrid, useTranslation } from '@common';
import * as Base from '@base';
import styles from '../style.module.less';
import { ImporterService } from '../service';
import type { ResultProps } from '../types';

export function Result({
  step,
  data,
  errors,
  definitions,
  status = 'success',
  title,
  subTitle,
  loading
}: ResultProps): ReactElement | null {
  const [t] = useTranslation();

  const { current: service } = useRef(new ImporterService());
  const agGridData = useMemo(() => {
    if (errors == null || data.length === 0 || step !== 3) {
      return data;
    }

    for (const error of errors) {
      data[error.index].__reason = { value: t(error.message), error: new Set([t(error.message)]) };
      data[error.index].__valid = { value: false };
    }

    return data;
  }, [errors, data, step]);

  if (step !== 3) {
    return null;
  }


  return (
    <div className={styles.stepContent}>
      <Block if={loading === true}>
        <Box className={styles.loadingContainer}>
          <Icons name='LoadingIcon' />
          <span>{t('导入中')}</span>
        </Box>
      </Block>

      <Block if={loading === false && status === 'success'}>
        <Base.Result status={status} title={title ?? t('数据导入成功')} subTitle={subTitle} />
      </Block>

      <Block if={loading === false && status === 'error'}>
        <AgGrid
          height={300}
          pagination={false}
          paginationPageSize={Number.MAX_SAFE_INTEGER}
          columns={service.parseTitle(definitions)}
          data={agGridData}
          defaultColDef={{
            filter: false,
            editable: false,
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
          }}
        />
      </Block>

    </div>
  );
}
